/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContourType } from '../models/ContourType';
import type { DeployRequest } from '../models/DeployRequest';
import type { EspFirmwareDto } from '../models/EspFirmwareDto';
import type { EspFirmwareDtoPagedResult } from '../models/EspFirmwareDtoPagedResult';
import type { EspFirmwareVersionInfoDto } from '../models/EspFirmwareVersionInfoDto';
import type { ParseEspFirmwareDto } from '../models/ParseEspFirmwareDto';
import type { ParseFirmwareRequest } from '../models/ParseFirmwareRequest';
import type { UpdateEspFirmwareRequest } from '../models/UpdateEspFirmwareRequest';
import type { UploadEspFirmwareRequest } from '../models/UploadEspFirmwareRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EspFirmwareService {
    /**
     * @param formData
     * @returns EspFirmwareDto Created
     * @throws ApiError
     */
    public static postApiEspFirmwares(
        formData?: UploadEspFirmwareRequest,
    ): CancelablePromise<EspFirmwareDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/esp-firmwares',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param page
     * @param pageSize
     * @param search
     * @returns EspFirmwareDtoPagedResult OK
     * @throws ApiError
     */
    public static getApiEspFirmwares(
        page: number = 1,
        pageSize: number = 20,
        search?: string,
    ): CancelablePromise<EspFirmwareDtoPagedResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/esp-firmwares',
            query: {
                'Page': page,
                'PageSize': pageSize,
                'Search': search,
            },
        });
    }
    /**
     * @param formData
     * @returns ParseEspFirmwareDto OK
     * @throws ApiError
     */
    public static postApiEspFirmwaresParse(
        formData?: ParseFirmwareRequest,
    ): CancelablePromise<ParseEspFirmwareDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/esp-firmwares/parse',
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static putApiEspFirmwares(
        id: string,
        requestBody: UpdateEspFirmwareRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/esp-firmwares/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiEspFirmwares1(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/esp-firmwares/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiEspFirmwares(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/esp-firmwares/{id}',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param formData
     * @returns any OK
     * @throws ApiError
     */
    public static putApiEspFirmwaresFile(
        id: string,
        formData?: {
            file: Blob;
        },
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/esp-firmwares/{id}/file',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiEspFirmwaresFile(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/esp-firmwares/{id}/file',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEspFirmwaresDeploy(
        id: string,
        requestBody: DeployRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/esp-firmwares/{id}/deploy',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static postApiEspFirmwaresRemoveFromContour(
        id: string,
        requestBody: DeployRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/esp-firmwares/{id}/remove-from-contour',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns any OK
     * @throws ApiError
     */
    public static getApiEspFirmwaresVersions(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/esp-firmwares/versions',
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiEspFirmwaresHistory(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/esp-firmwares/{id}/history',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static getApiEspFirmwaresDownload(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/esp-firmwares/{id}/download',
            path: {
                'id': id,
            },
        });
    }
    /**
     * @param espType
     * @param currentVersion
     * @param contour
     * @returns EspFirmwareVersionInfoDto OK
     * @throws ApiError
     */
    public static getApiEspFirmwaresCurrent(
        espType: string,
        currentVersion: string,
        contour?: ContourType,
    ): CancelablePromise<EspFirmwareVersionInfoDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/esp-firmwares/current',
            query: {
                'EspType': espType,
                'CurrentVersion': currentVersion,
                'Contour': contour,
            },
            errors: {
                404: `Not Found`,
            },
        });
    }
}
